import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAgentsAdminContext } from "../providers/agents-admin.provider";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import { useAuthAgentGetMe } from "../../../../services/microservice/admin/auth/use-auth-agents";

const AdminSidebar = () => {
  const { sponsor, setStep } = useAgentsAdminContext();
  const { data: Agent } = useAuthAgentGetMe();
  const navigate = useNavigate();
  const { logout } = useLoginUser();

  const handleLogout = () => {
    logout();
    navigate(`/${sponsor}/admin/`);
    setStep(1);
  };

  return (
    <div className="flex h-full w-1/6 flex-col items-center justify-between bg-white pb-10 pt-40">
      <div className="flex w-full items-center justify-center">
        <ul className="mt-4 space-y-4">
          <li className="my-5 mt-1 hover:underline hover:underline-offset-4 lg:my-0">
            <Link to={`/${sponsor}/admin/agents`}> Lista de agentes</Link>
          </li>
          <li className="my-5 mt-1 hover:underline hover:underline-offset-4 lg:my-0">
            <Link to={`/${sponsor}/admin/agents/create`}>
              Creacion de agentes
            </Link>
          </li>
          {Agent?.data?.user?.roles[0]?.idSystem === "SUPERADMIN" && (
            <>
              <li className="my-5 mt-1 hover:underline hover:underline-offset-4 lg:my-0">
                <Link to={`/${sponsor}/admin/sponsors`}>Lista de sponsor</Link>
              </li>
              <li className="my-5 mt-1 hover:underline hover:underline-offset-4 lg:my-0">
                <Link to={`/${sponsor}/admin/sponsors/create`}>
                  Creacion de sponsor
                </Link>
              </li>
            </>
          )}
        </ul>
      </div>
      <ul className="mt-4 space-y-4">
        <button onClick={() => handleLogout()}>
          <li className="my-5 mt-1 hover:underline hover:underline-offset-4 lg:my-0">
            Cerrar sesión
          </li>
        </button>
      </ul>
    </div>
  );
};
export default AdminSidebar;
